import React from 'react';
import Modal from './Modal';
import { AlertTriangle } from 'lucide-react';

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'warning'
}) => {
  const getTypeStyles = () => {
    switch (type) {
      case 'danger':
        return {
          icon: 'text-[#f38b83]',
          bg: 'bg-[#341a17]',
          button: 'bg-[#f38b83] hover:bg-[#f7aca6]'
        };
      case 'warning':
        return {
          icon: 'text-[#f0b64c]',
          bg: 'bg-[#332711]',
          button: 'bg-[#f0b64c] hover:bg-[#f5c876]'
        };
      case 'info':
        return {
          icon: 'text-[#60a5fa]',
          bg: 'bg-[#16212b]',
          button: 'bg-[#60a5fa] hover:bg-[#93c5fd]'
        };
      default:
        return {
          icon: 'text-[#f0b64c]',
          bg: 'bg-[#332711]',
          button: 'bg-[#f0b64c] hover:bg-[#f5c876]'
        };
    }
  };

  const styles = getTypeStyles();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" showCloseButton={false}>
      <div className="text-center">
        {/* Icon */}
        <div className={`mx-auto flex items-center justify-center w-12 h-12 rounded-full ${styles.bg} mb-4`}>
          <AlertTriangle className={`w-6 h-6 ${styles.icon}`} />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-[#f3ede2] mb-2">
          {title}
        </h3>

        {/* Message */}
        <p className="text-[#b9ad9b] mb-6">
          {message}
        </p>

        {/* Actions */}
        <div className="flex items-center justify-center space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-[#b9ad9b] bg-transparent border border-[#3a3122] rounded-lg hover:bg-[#28221a] transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`px-4 py-2 text-white rounded-lg transition-colors ${styles.button}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;